import { useNavigate, useParams } from "react-router-dom";
import { Box, IconButton } from "@mui/material";

import { Entity } from "../../../../../types/types";

import { EditEntityProfileSectionButtonIcon } from "../../../assets/icons/entity-icons";

import AgeGroups from "./AgeGroups";
import GeneralInfo from "./GeneralInfo";
import EntityActivity from "./EntityActivity";
import { EntityLocations } from "./EntityLocations";
import EntityAchievements from "./EntityAchievements";
import { getEntityProfileEditRoute } from "../../../../../routers/routeUtils";

interface HomeTabProps {
  entity?: Entity;
  isLoading: boolean;
}

const HomeTab = ({ entity, isLoading }: HomeTabProps) => {
  const navigate = useNavigate();

  const { entityId } = useParams();

  const handleEditEntityProfileSection = (tab: string) => navigate(getEntityProfileEditRoute(entityId!, tab));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <GeneralInfo entity={entity} isLoading={isLoading} />
      <AgeGroups entity={entity} isLoading={isLoading} />
      <EntityAchievements />
      <Box
        sx={{
          display: "flex",
          padding: "20px",
          flexDirection: "column",
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          background: "#FFF",
          gap: "16px",
          position: "relative",
        }}
      >
        <IconButton
          size="small"
          onClick={() => handleEditEntityProfileSection("locations")}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <EditEntityProfileSectionButtonIcon />
        </IconButton>
        <EntityLocations />
      </Box>
      <EntityActivity userId={String(entity?.userId)!} isLoading={isLoading} />
    </Box>
  );
};

export default HomeTab;
